const CropStageMaster = {

    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    "cropStageMaster": "Crop Stage Master",

    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

    "table_name": "NAME",
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",

}

export default CropStageMaster;
